
import React from 'react';
import { TagInput } from '@/components/ui/tag-input';

interface TaskCategoryFilterProps {
  selectedCategories: string[];
  onCategoriesChange: (categories: string[]) => void;
  availableCategories: { label: string; value: string }[];
}

const TaskCategoryFilter: React.FC<TaskCategoryFilterProps> = ({
  selectedCategories,
  onCategoriesChange,
  availableCategories,
}) => {
  return (
    <TagInput
      selected={selectedCategories}
      options={availableCategories}
      onChange={onCategoriesChange}
      placeholder="Categories"
      creatable={true}
    />
  );
};

export default TaskCategoryFilter;
